import React from "react";
import classes from "./YahooChevronIndicators.module.scss";

const chevrons = [
  { size: 14, opacity: 0.35 },
  { size: 20, opacity: 0.6 },
  { size: 26, opacity: 1 },
  { size: 20, opacity: 0.6 },
  { size: 14, opacity: 0.35 },
];

export function YahooChevronIndicators() {
  return (
    <div className={ classes.chevronRow } aria-hidden="true">
      {chevrons.map((c, i) => (
        <svg
          key={ i }
          width={ c.size }
          height={ c.size }
          viewBox="0 0 24 24"
          fill="none"
          style={{ opacity: c.opacity }}
          className={ classes.chevron }
        >
          <path
            d="M6 9l6 6 6-6"
            stroke="#17C4D4"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ))}
    </div>
  );
}
